import React, { createElement, FC, ReactElement } from 'react';

import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import ResearchFormWizardStep from 'buyside/components/presentation/ResearchFormWizard/researchFormWizardStep';
import ResearchFormWizardSubmissionButtons from 'buyside/components/presentation/ResearchFormWizard/researchFormWizardSubmissionButtons';

import { IdeaFormInput, WhitePaperFormInput } from 'buyside/util/researchSubmission';

import styles from './researchFormWizardStyles.scss';

export type ResearchWizardStep = {
  component: FC | (() => ReactElement);
  label: string;
  name: string;
};

const ResearchFormWizard: FC<{
  completedSteps: ResearchWizardStep[];
  currentStep: ResearchWizardStep;
  handleSetCurrentStep: (step: ResearchWizardStep) => void;
  isDraft: boolean;
  researchPath: string;
  steps: ResearchWizardStep[];
  researchType: 'Idea' | 'Macro/Thematic Report';
  handleCreateOrUpdateDraft: (
    values: IdeaFormInput & WhitePaperFormInput,
    nextStep: ResearchWizardStep,
    isSubmission: boolean
  ) => Promise<any>;
}> = ({
  completedSteps,
  currentStep,
  handleCreateOrUpdateDraft,
  handleSetCurrentStep,
  isDraft,
  researchPath,
  researchType,
  steps
}) => (
  <div className={styles.researchFormWizard}>
    <div className={styles.researchFormWizardHeader}>
      <h4>
        Submit {researchType === 'Idea' ? 'an' : 'a'} {researchType}
      </h4>
      <div className={styles.researchFormWizardSteps}>
        {steps.map((step, index) => (
          <ResearchFormWizardStep
            {...step}
            key={`${step.name}_step`}
            isActive={step === currentStep}
            isCompleted={completedSteps.includes(step)}
            isPreviousStepCompleted={completedSteps.includes(steps[index - 1])}
            onClick={() => handleSetCurrentStep(step)}
            stepCount={index + 1}
          />
        ))}
      </div>
    </div>
    <ErrorBoundary pageName={currentStep.label}>
      {createElement(currentStep.component)}
    </ErrorBoundary>
    <ResearchFormWizardSubmissionButtons
      currentStep={currentStep}
      handleCreateOrUpdateDraft={handleCreateOrUpdateDraft}
      handleSetCurrentStep={handleSetCurrentStep}
      isDraft={isDraft}
      researchPath={researchPath}
      researchType={researchType}
      steps={steps}
    />
  </div>
);

export default ResearchFormWizard;
